module.exports = __webpack_public_path__ + "img/vasile.dc47221b.png";